// Vendors
import { apiUtils } from '@openbank/cf-ui-architecture-core';
// Constants
import {
  GENERATE_OTP_SERVICE_CONFIGURATION,
  GENERATE_SCREEN_DETAILS_SERVICE_CONFIGURATION,
  SAVE_SCREEN_SERVICE_CONFIGURATION,
} from './constants/contract.view.services.constants';
// Types
import { ContractViewDataApiResponseType } from '../types/contract-view-data-api-response.type';
import { ContractConsentViewType } from '../hooks/types/contract.view.hook.types';

const getScreenDetailsService = async (): Promise<[ContractViewDataApiResponseType, Response]> =>
  apiUtils.get(GENERATE_SCREEN_DETAILS_SERVICE_CONFIGURATION);

const saveScreenService = async (consents: ContractConsentViewType[]): Promise<[null, Response]> =>
  apiUtils.post({
    ...SAVE_SCREEN_SERVICE_CONFIGURATION,
    params: { consents },
  });

const generateOtpIdService = async (): Promise<[{ otpId: string }, Response]> =>
  apiUtils.post({
    ...GENERATE_OTP_SERVICE_CONFIGURATION,
  });

export { getScreenDetailsService, saveScreenService, generateOtpIdService };
